import { baseFilters } from '@/utils/baseFilters';
import { notificationsMixin } from './notifications';

export function listMixin(moduleName, onPage) {
  return {
    mixins: [notificationsMixin],
    methods: {
      // Zwraca filtry listy
      filters(route) {
        return baseFilters(route, onPage);
      },

      // Aktualizuje listę
      updateList(route) {
        return this.$store.dispatch(`${moduleName}/list`, this.filters(route));
      }
    },

    beforeRouteUpdate(to, _from, next) {
      this.updateList(to)
        .then(() => next())
        .catch(() => this.notifyError('Nie udało się pobrać listy. Spróbuj ponownie.'));
    }
  };
}
